<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row" v-if="userData.permissions['report_comments']==1">

    <div class="row">
      <div class="col-12">
        <div class="card shadow-lg">
          <div class="card-body">
            <div class="d-flex justify-content-between align-items-center">
              <div class="fw-medium text-success">Note: The latest Comment Group applies to the report.</div>
             
            </div>
            <div class="d-flex justify-content-end gap-2">
                <div><b-button size="sm" variant="success" 
                  @click.prevent="$bvModal.show('add-comment-group'); toggleAddFormWizard();"><i
                    class="mdi mdi-plus"></i>
                  Comment Group</b-button></div>
            </div>
            <div class="my-2">

            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm"
                      :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..."
                      class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table :items="Items" :fields="Fields" responsive="sm" :per-page="perPage" :current-page="currentPage"
                :filter="filter" :filter-included-fields="filterOn" @filtered="Filtered" :busy="IsBusy">
                <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow"
                      small></b-spinner> <strong>No Data</strong></div>
                </template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>

                <template #cell(class)="data">
                  {{ data.item.class }}
                  <small v-if="data.item.stream" class="d-block text-primary fw-medium">Stream: {{ data.item.stream
                  }}</small>
                </template>

                <template #cell(status)="data">
                  <span v-if="data.item.status == 1" class="badge text-white bg-primary">Class Teacher</span>
                  <span v-if="data.item.status == 2" class="badge text-white bg-success">Head Teacher</span>
                </template>

                <template #cell(actions)="data">
                  <button @click.prevent="preview(data.item.id, data.item.class, data.item.stream, data.item.status)" class="btn btn-sm btn-info"><i
                      class="mdi mdi-eye"></i></button>
                  <button
                    @click.prevent="editModal = true; edit(data.item.id, data.item.class_id, data.item.stream_id, data.item.status);"
                    class="btn btn-sm btn-primary"><i class="mdi mdi-pencil"></i></button>
                  <button @click.prevent="remove(data.item.id, data.item.class, data.item.stream)"
                    class="btn btn-sm btn-danger"><i class="mdi mdi-trash-can"></i></button>
                </template>

              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="add-comment-group" size="" centered
      :title="`${editModal ? 'Edit' : 'New'} Comment Group for ${commentor}`" hide-footer>
      <div class="text-center" v-if="loader">
        <b-spinner class="text-primary" small></b-spinner>
        <p class="fw-medium text-primary">Loading...</p>
      </div>
      <div v-else class="">
        <form-wizard v-if="showWizard" :start-index="0"
          @on-complete="editModal ? editCommentGroup() : addCommentGroup()" shape="pill" back-button-text="Back"
          next-button-text="Next" :finish-button-text="editModal ? `Edit` : `Submit`" color="#ef2c01">
          <tab-content title="Comment Group" icon="mdi mdi-text-box-plus" :before-change="validateAdminTab1">
            <label class="fw-medium mb-1">Comment Group for:</label>
            <div v-show="status != 1" class="justify-content-start mb-3">
              <button @click.prevent="selectedButton = 2" v-show="status == 3 || status == 2" class="btn mx-1"
                :class="{ 'btn-dark': selectedButton == 2, 'btn-sm btn-outline-primary': selectedButton != 2 }">Head Teacher</button>
              <button @click.prevent="selectedButton = 1" v-show="status == 3 || status == 1" class="btn mx-1"
                :class="{ 'btn-dark': selectedButton == 1, 'btn-sm btn-outline-primary': selectedButton != 1 }">Class
                Teacher</button>
              <small v-if="selectedButton == 2" class="mt-2 d-block text-primary fw-medium">Add Comment Groups for a
                class
                as 
                an Head Teacher</small>
              <small v-if="selectedButton == 1" class="mt-2 d-block text-primary fw-medium">Add Comment Groups for the
                stream
                as a Class Teacher</small>
            </div>
            <hr>
            <div class="row">
              <div class="col-12 mb-2">
                <label class="mb-0" for="class">Class</label>
                <v-select placeholder="Choose Class" label="name" :options="schoolclasses.filter(c => c.level == 2)" v-model="school_class"
                  @input="onClassChange"></v-select>
                <span class="text-danger" v-if="school_class_error">{{ school_class_error }}</span>
              </div>
              <div class="col-12" v-show="selectedButton == 1">
                <label class="mb-0" for="class">Stream</label>
                <v-select placeholder="Choose Stream" label="name" :options="class_streams"
                  v-model="class_stream"></v-select>
                <span class="text-danger" v-if="class_stream_error">{{ class_stream_error }}</span>
              </div>

              <div class="col-12 mb-2">
                <label class="mb-0" for="signature">Signature</label>
                <input id="signature" type="file" accept="image/*" class="form-control" @change="handleImage"/>
              </div>
            </div>
          </tab-content>

          <tab-content title="Group Details" icon="mdi mdi-comment-text-outline" :before-change="validateAdminTab2">
            <div class="row">
              <div class="col-5">
                <div class="row">
                  <div class="">GRADE</div>
                  <hr>
                  <div class="col-12">
                    <input readonly class="text-primary fw-medium form-control my-1" placeholder="A" v-model="start_1">
                  </div>
                  <div class="col-12">  
                    <input readonly class="text-primary fw-medium form-control my-1" placeholder="B" v-model="start_2">
                  </div>
                  <div class="col-12">
                    <input readonly class="text-primary fw-medium form-control my-1" placeholder="C" v-model="start_3">
                  </div>
                  <div class="col-12">
                    <input readonly class="text-primary fw-medium form-control my-1" placeholder="D" v-model="start_4">
                  </div>
                  <div class="col-12">
                    <input readonly class="text-primary fw-medium form-control my-1" placeholder="E" v-model="start_5">
                  </div>
                </div>
              </div>
              <div class="col-7">
                <div class="row">
                  <div class="">COMMENT</div>
                  <hr>
                  <input class="form-control my-1" v-model="comment_1" placeholder="Enter comment for grade A..." />
                  <input class="form-control my-1" v-model="comment_2" placeholder="Enter comment for grade B..." />
                  <input class="form-control my-1" v-model="comment_3" placeholder="Enter comment for grade C..." />
                  <input class="form-control my-1" v-model="comment_4" placeholder="Enter comment for grade D..." />
                  <input class="form-control my-1" v-model="comment_5" placeholder="Enter comment for grade E..." />
                  <br>
                  <hr>
                </div>
              </div>
            </div>
          </tab-content>

          <tab-content title="Preview" icon="mdi mdi-eye">
            <div class="row">
              <div class="col-12">
                <h5>Class: {{ school_class ? school_class.name : '' }}</h5>
                <h6 v-if="selectedButton == 1" class="text-primary">Stream: {{ class_stream ? class_stream.name : '' }}
                </h6>
                <hr>
                <div class="row">
                  <div class="col-5">
                    <div class="row">
                      <div class="col-6 my-1 fw-medium">GRADE</div>
                      <hr>
                      <div class="col-12 my-1">{{ start_1 }}</div>
                      <div class="col-12 my-1">{{ start_2 }}</div>
                      <div class="col-12 my-1">{{ start_3 }}</div>
                      <div class="col-12 my-1">{{ start_4 }}</div>
                      <div class="col-12 my-1">{{ start_5 }}</div>
                    </div>
                  </div>
                  <div class="col-7">
                    <div class="row">
                      <div class="col-6 my-1 fw-medium">COMMENT</div>
                      <hr>
                      <div class="my-1">{{comment_1}}</div>
                      <div class="my-1">{{comment_2}}</div>
                      <div class="my-1">{{comment_3}}</div>
                      <div class="my-1">{{comment_4}}</div>
                      <div class="my-1">{{comment_5}}</div>
                    </div>
                  </div>
                </div>
                <br>
              </div>
              <hr>
            </div>
          </tab-content>
        </form-wizard>
      </div>
    </b-modal>

    <b-modal id="delete-comment-group" centered title="Delete Comment Group" hide-footer>
      <div class="text-center">
        <p class="fw-medium mb-3">Are you sure you want to delete this comment group?</p>
        <b-button variant="danger" class="mx-2" @click="confirmDeleteCommentGroup">Delete</b-button>
        <b-button variant="secondary" class="mx-2" @click="$bvModal.hide('delete-comment-group')">Cancel</b-button>
      </div>
    </b-modal>

    <b-modal id="preview-comment-group" centered title="Preview Comment Group" hide-footer>
      <div v-if="previewGroup">
        <h5>Class: {{ school_class }}</h5>
        <h6 v-if="class_stream" class="text-primary">Stream: {{ class_stream }}</h6>
        <span class="me-2 text-primary fw-medium">Type:</span><span v-if="status == 1" class="badge text-white bg-primary"> Class Teacher</span>
        <span v-if="status == 2" class="badge text-white bg-success"> Head Teacher</span>
        <hr>
        <div class="row">
          <div class="col-5">
            <div class="row">
              <div class="col-6 fw-bold">GRADE</div>
            </div>
            <hr>
            <div class="row"
              v-for="(detail, idx) in previewGroup.details.filter(d => d.grade !== null)"
              :key="idx">
              <div class="col-6 my-1"><strong >{{ detail.start_agg }}</strong></div>
            </div>

          </div>
          <div class="col-7">
            <div class="row">
              <div class="col-6 fw-bold">Comment</div>
            </div>
            <hr>
            <div class="row" v-for="(detail, idx) in previewGroup.details.filter(d => d.grade !== null)"
              :key="idx + '_c'">
              <div class="col-6 my-1">{{ detail.comment }}</div>
            </div>

          </div>
        </div>
        <br>
      </div>
      <div v-else>
        <b-spinner class="text-primary" small></b-spinner>
        <p class="fw-medium text-primary">Loading...</p>
      </div>
    </b-modal>

  </div>  
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div> 
    </div>

  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {
  commentgroupsComputed,
  commentgroupsMethods,
  schoolclassComputed,
  schoolclassMethods,
} from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "General Comments",
    meta: [{ name: "description", content: appConfig.description, },],
  },
  components: {
    Layout, PageHeader,
  }, 
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "General Report Comments",
      items: [{ text: "Dashboard", to: "/", }, { text: "General Report Comments", active: true, },],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
        { key: 'index', label: '#', visible: true },
        { key: 'id', label: 'ID', visible: false },
        { key: 'class', label: 'Class', visible: true },
        { key: 'status', label: 'Type', visible: (JSON.parse(localStorage.getItem("user")).permissions.set_admin_comments & JSON.parse(localStorage.getItem("user")).permissions.set_classteacher_comments) },
        { key: 'created_at', label: 'Added on', visible: true },
        { key: 'actions', label: 'Actions', visible: true },
      ],

      showWizard: false,
      status: 0,
      signature: null,
      selectedButton: 0,
      
      // Grade values - now fixed to A, B, C, D, E
      start_1: 'A',
      start_2: 'B',
      start_3: 'C',
      start_4: 'D',
      start_5: 'E',
      
      // Comments for each grade
      comment_1: "",
      comment_2: "",
      comment_3: "",
      comment_4: "",
      comment_5: "",

      previewGroup: null,
      school_class: null,
      class_stream: null,
      class_streams: [],
      school_class_error: "",
      class_stream_error: "",
      loader: false,
      editModal: false,
      id: '',
      detail_ids: [],
    };
  },

  computed: {
    ...commentgroupsComputed,
    ...schoolclassComputed,
    List() { return this.commentgroups.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.commentgroups.map((d) => ({ ...d })) },
    IsBusy() { let a = false; if (this.commentgroups.length > 0) { a = false; } else { a = true; } return a },

    commentor() {
      if (this.selectedButton == 1) {
        return "Class Teacher";
      } else if (this.selectedButton == 2) {
        return "Head Teacher";
      } else {
        return "Unknown";
      }
    }
  },

  mounted() {
    this.setStatus();
    this.fetchCommentGroups();
    this.fetchSchoolClasses();
  },

  methods: {
    ...commentgroupsMethods,
    ...schoolclassMethods,
    
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    
    setStatus() {
      const admin_permission = this.userData.permissions.set_admin_comments;
      const classteacher_permission = this.userData.permissions.set_classteacher_comments;

      if (admin_permission == 1 && classteacher_permission == 1) {
        this.status = 3;
        this.selectedButton = 2;
      } else if (admin_permission == 1 && classteacher_permission == 0) {
        this.status = 2;
        this.selectedButton = 2;
      } else if (admin_permission == 0 && classteacher_permission == 1) {
        this.status = 1;
        this.selectedButton = 1;
      }
    },

    toggleAddFormWizard() {
      this.showWizard = false;
      this.showWizard = true;
      this.editModal = false;
      this.loader = false;
    },

    toggleEditFormWizard() {
      this.showWizard = false;
      this.showWizard = true;
      this.editModal = true;
      this.loader = true;
    },

    onClassChange() {
      this.class_stream = null;
      if (!this.school_class) return;
      axios.get(`/findschoolstream/${this.school_class.id}`)
        .then(response => {
          if (response.status === 200) {
            this.class_streams = response.data.streams;
          } else {
            this.$swal({ title: 'Error', text: 'Failed to fetch streams.', icon: 'error' });
          }
        })
        .catch(() => {
          this.$swal({ title: 'Error', text: 'Failed to fetch streams.', icon: 'error' });
        });
    },

    validateAdminTab1() {
      let valid = true;

      if (!this.school_class || typeof this.school_class !== 'object' || !this.school_class.id) {
        this.school_class_error = "Class is required";
        valid = false;
      } else {
        this.school_class_error = "";
      }

      if (this.selectedButton == 1) {
        if (!this.class_stream || typeof this.class_stream !== 'object' || !this.class_stream.id) {
          this.class_stream_error = "Stream is required";
          valid = false;
        } else {
          this.class_stream_error = "";
        }
      } else {
        this.class_stream_error = "";
      }

      return valid;
    },

    validateAdminTab2() {
      // Simple validation - at least one comment should be provided
      const hasComment = this.comment_1 || this.comment_2 || this.comment_3 || this.comment_4 || this.comment_5;
      if (!hasComment) {
        this.$swal({ title: 'Warning', text: 'Please provide at least one comment.', icon: 'warning' });
        return false;
      }
      return true;
    },

    async preview(id, school_class, stream, status) {
      this.loader = true;
      this.id = id;
      this.school_class = school_class;
      this.class_stream = stream;
      this.status = status;
      try {
        const response = await axios.get(`/comment-group-details/${id}`);
        if (response.status === 200) {
          this.previewGroup = response.data;
          this.$bvModal.show("preview-comment-group");
        } else {
          this.$swal({ title: 'Error', text: 'Failed to fetch comment group details.', icon: 'error' });
        }
      } catch (error) {
        this.$swal({ title: 'Error', text: 'Failed to fetch comment group details. Please try again.', icon: 'error' });
      } finally {
        this.loader = false;
      }
    },

    async edit(id, school_class, stream, status) {
      this.$bvModal.show("add-comment-group");
      this.toggleEditFormWizard();
      this.id = id;
      this.selectedButton = status;
      this.school_class = this.schoolclasses.find(cls => cls.id === school_class) || null;
      
      const [, response] = await Promise.all([
        this.onClassChange(),
        axios.get(`/comment-group-details/${id}`),
      ]);
      
      this.class_stream = this.class_streams.find(str => str.id === stream) || null;

      if (response.status == 200) {
        const data = response.data.details;
        
        // Map the comments based on grade
        data.forEach(detail => {
          switch(detail.grade) {
            case 'A':
              this.comment_1 = detail.comment;
              break;
            case 'B':
              this.comment_2 = detail.comment;
              break;
            case 'C':
              this.comment_3 = detail.comment;
              break;
            case 'D':
              this.comment_4 = detail.comment;
              break;
            case 'E':
              this.comment_5 = detail.comment;
              break;
          }
        });

        this.loader = false;
      } else {
        this.$swal({ title: 'Error', text: 'Failed to fetch comment group details.', icon: 'error' });
        this.loader = false;
      }
    },

    remove(id, school_class, stream) {
      this.id = id
      this.school_class = school_class;
      this.class_stream = stream;
      this.$bvModal.show("delete-comment-group");
    },

    async addCommentGroup() {
      const formData = new FormData();

      if (this.signature) {
        formData.append('signature', this.signature);
      }

      formData.append('school_class', this.school_class.id);
      formData.append('status', this.selectedButton);

      if (this.selectedButton == 1 && this.class_stream && this.class_stream.id) {
        formData.append('stream', this.class_stream.id);
      }

      const comments = [];
      
      // Add comments for each grade if they exist
      if (this.comment_1) comments.push({ grade: 'A', comment: this.comment_1 });
      if (this.comment_2) comments.push({ grade: 'B', comment: this.comment_2 });
      if (this.comment_3) comments.push({ grade: 'C', comment: this.comment_3 });
      if (this.comment_4) comments.push({ grade: 'D', comment: this.comment_4 });
      if (this.comment_5) comments.push({ grade: 'E', comment: this.comment_5 });

      // Append comments as array
      comments.forEach((comment, index) => {
        formData.append(`comments[${index}][grade]`, comment.grade);
        formData.append(`comments[${index}][comment]`, comment.comment);
      });

      try {
        const response = await axios.post("/add-comment-group", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.status == 201) {
          this.fetchCommentGroups();
          this.$bvModal.hide("add-comment-group");
          this.resetData();
          this.$swal({ title: 'Success', text: 'New Comment Group Added!', icon: 'success' });
        } else if (response.status == 409) {
          this.$swal({ title: 'Error', text: 'Comment group already exists.', icon: 'error' });
        }
      } catch (error) {
        this.$swal({ title: 'Error', text: 'Failed to add comment group.', icon: 'error' });
      }
    },

    async editCommentGroup() {
      if (!this.validateAdminTab1() || !this.validateAdminTab2()) {
        return;
      }

      const formData = new FormData();
      formData.append('id', this.id);
      formData.append('school_class', this.school_class.id);
      formData.append('status', this.selectedButton);

      if (this.selectedButton == 1 && this.class_stream && this.class_stream.id) {
        formData.append('stream', this.class_stream.id);
      }

      if (this.signature) {
        formData.append('signature', this.signature);
      }

      const comments = [];
      
      // Add comments for each grade if they exist
      if (this.comment_1) comments.push({ grade: 'A', comment: this.comment_1 });
      if (this.comment_2) comments.push({ grade: 'B', comment: this.comment_2 });
      if (this.comment_3) comments.push({ grade: 'C', comment: this.comment_3 });
      if (this.comment_4) comments.push({ grade: 'D', comment: this.comment_4 });
      if (this.comment_5) comments.push({ grade: 'E', comment: this.comment_5 });

      // Append comments as array
      comments.forEach((comment, index) => {
        formData.append(`comments[${index}][grade]`, comment.grade);
        formData.append(`comments[${index}][comment]`, comment.comment);
      });

      try {
        const response = await axios.post("/update-comment-group", formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.status == 200) {
          this.fetchCommentGroups();
          this.$bvModal.hide("add-comment-group");
          this.resetData();
          this.$swal({ title: 'Success', text: 'Comment Group Updated!', icon: 'success' });
        } else {
          this.$swal({ title: 'Error', text: response.data.error, icon: 'error' });
        }
      } catch (error) {
        this.$swal({ title: 'Error', text: 'Failed to update comment group. Please try again.', icon: 'error' });
      }
    },

    confirmDeleteCommentGroup() {
      const obj = {
        id: this.id
      }
      axios.post(`/delete-comment-group/`, obj)
        .then(response => {
          if (response.status == 200) {
            this.fetchCommentGroups();
            this.$bvModal.hide("delete-comment-group");
            this.$swal({ title: 'Success', text: 'Comment Group Deleted!', icon: 'success' });
          } else {
            this.$swal({ title: 'Error', text: response.data.error, icon: 'error' });
          }
        })
        .catch(() => {
          this.$swal({ title: 'Error', text: 'Failed to delete comment group. Please try again.', icon: 'error' });
        });
    },

    resetData() {
      this.school_class = null;
      this.class_stream = null;
      this.signature = null;
      this.comment_1 = "";
      this.comment_2 = "";
      this.comment_3 = "";
      this.comment_4 = "";
      this.comment_5 = "";
    },

    handleImage(e) { 
      this.signature = e.target.files[0]; 
    },

    view(item) {
      const fileUrl = this.getFiles(item.signature);
      window.open(fileUrl, '_blank');
    },
  },
};
</script>

<style></style>